export const isNonEmptyString = value =>
  typeof value === 'string' && value.length > 0;

export const formatTitle = specificPart =>
  `ADCOproto — ${specificPart}`;
